import React from 'react';
import styled from 'styled-components';

import { FontFamily } from '@zocdoc/components/src/typography';

const InfoStyles = styled.div`
    display: inline-block;
    margin-top: 8px;
    font: 15px/24px ${FontFamily.SharpSansSemibold};
    h4 {
        font: 15px/24px ${FontFamily.SharpSansBold};
    }
    h5 {
        font: 15px/24px ${FontFamily.SharpSansBold};
    }
    h6 {
        font: 15px/24px ${FontFamily.SharpSansBold};
    }
    p {
        margin-bottom: 8px;
    }
`;

export default class LocationInfoStyle extends React.PureComponent {
    render() {
        return (
            <InfoStyles data-test="location-info">
                {this.props.children}
            </InfoStyles>
        );
    }
}
